/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsLoginAuthChallenge204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsLoginAuthChallenge505Schema = z.any();

export const optionsLoginAuthChallengeMutationResponseSchema = z.lazy(() => optionsLoginAuthChallenge204Schema);
